import { Button, Typography } from "@material-ui/core"
import { createTheme, ThemeProvider, useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom"
import Package from "../package.json"
import DivulgacoesPainel from "./pages/DivulgacoesPainel"
import Facebook from "./pages/Facebook"
import BannerQuitacao from "./pages/QuitacaoAutomatica/BannerQuitacao"

import CadastroEstabelecimento from "./pages/CadastroEstabelecimento"
import Caixa from "./pages/Caixa"
import Filter from "./pages/Filter"
import GeradorDeQrCode from "./pages/GeradorDeQrCode"
import { Index as HistoricoCaixa } from "./pages/HistoricoCaixa"
import HistoricoPedidos from "./pages/HistoricoPedidos"
import Login from "./pages/Login"
import NotaFiscal from "./pages/NotaFiscal"
import OnboardingRestaurante from "./pages/OnboardingRestaurante"
import PedidosDoDia from "./pages/PedidosDoDia"
import RecebedorDePedidos from "./pages/RecebedorDePedidos"
import RealizadorDePedidos from "./pages/RegistradorDePedidos"
import Servicos from "./pages/Servicos"
import Teste from "./pages/Teste"

import AreaDeEntregas from "./pages/AreaEntregas"
import Cardapio from "./pages/Cardapio"
import EditarAplicativo from "./pages/EditarAplicativo"
import CriarAplicativo from "./pages/CriarAplicativo"
import Galeria from "./pages/Galeria"
import GerenciadorMesas from "./pages/GerenciadorMesas"
import PedidoDeMesaQrCode from "./pages/PedidoDeMesaQrCode"
import QRCodeMesa from "./pages/QRCodeMesa"

import { useEffect } from "react"
import { ConfiguracoesAgendamento } from "./pages/Agendamento/ConfiguracoesAgendamento"
import { PedidosAgendados } from "./pages/Agendamento/PedidosAgendados"
import { PeriodoAgendamento } from "./pages/Agendamento/PeriodoAgendamento"
import { Index as AlertasPainel } from "./pages/AlertasPainel"
import { Index as AtribuirBairros } from "./pages/AtribuirBairros"
import { Index as AtribuirFaixasDistancia } from "./pages/AtribuirFaixasDistancia"
import { Index as AtribuirRegiao } from "./pages/AtribuirRegiao"
import { Index as AvaliacaoDelivery } from "./pages/AvaliacaoDelivery"
import { Index as BrindesFornecedor } from "./pages/BrindesFornecedor"
import { Index as BrindesResgatadosFornecedor } from "./pages/BrindesResgatadosFornecedor"
import {
    Index as CadastroAplicativoFornecedor,
    IndexArquivos as CadastroAplicativoFornecedorArquivos,
    IndexCadastro as CadastroAplicativoFornecedorCadastro,
    IndexContrato as CadastroAplicativoFornecedorContrato,
    IndexEstabelecimentos as CadastroAplicativoFornecedorEstabelecimentos,
    IndexParametros as CadastroAplicativoFornecedorParametros,
} from "./pages/CadastroAplicativoFornecedor"
import { Index as CadastroBannerFornecedor } from "./pages/CadastroBannerFornecedor"
import { Index as CadastroPromocaoFidelidade } from "./pages/CadastroPromocaoFidelidade"
import { Index as ClubeBeneficios } from "./pages/ClubeBeneficios"
import { Index as CartelasFornecedor } from "./pages/CartelasFornecedor"
import { Index as ClientesFornecedor } from "./pages/ClientesFornecedor"
import { Index as ComparativoUnidades } from "./pages/ComparativoUnidades"
import {
    IndexParametrosAvancados as ConfiguracaoDeliveryAvancados,
    IndexParametrosClienteFiel as ConfiguracaoDeliveryClienteFiel,
    IndexParametrosDelivery as ConfiguracaoDeliveryParametros,
    IndexParametrosIntegracao as ConfiguracaoDeliveryIntegracao,
} from "./pages/ConfiguracaoDeliveryFornecedor"
import { Index as ConfiguracaoFiscal } from "./pages/ConfiguracaoFiscal"
import { Index as ConfiguracaoFormasDePagamento } from "./pages/ConfiguracaoFormasDePagamento"
import ConversasWhatsapp from "./pages/ConversasWhatsapp"
import CriarTemplateWhatsapp from "./pages/CriarTemplateWhatsapp"
import { Index as CupomEstabelecimentoFornecedor } from "./pages/CupomEstabelecimentoFornecedor"
import { Index as DadosBancariosSubconta } from "./pages/DadosBancariosSubconta"
import { Index as DadosFornecedor } from "./pages/DadosFornecedor"
import { Index as EdicaoCliente } from "./pages/EdicaoCliente"
import { Index as EmissaoCupomFiscal } from "./pages/EmissaoCupomFiscal"
import { Index as EmissoesParaMeuCNPJ } from "./pages/EmissoesParaMeuCNPJ"
import ImportarNotasCompra from "./pages/ImportarNotasCompra"
import { Index as EnderecosBloqueados } from "./pages/EnderecosBloqueados"
import EnvioTemplateWhatsappGrupo from "./pages/EnvioTemplateWhatsappGrupo"
import { Index as EstrategiasFornecedor } from "./pages/EstrategiasFornecedor"
import { Index as ExtratoPagarmeFornecedor } from "./pages/ExtratoPagarmeFornecedor"
import { Index as ExtratoPixFornecedor } from "./pages/ExtratoPixFornecedor"
import { Faturas } from "./pages/Faturas"
import MesasFechadas from "./pages/GerenciadorMesas/HistoricoDeMesas"
import { Index as GerenciamentoIfood } from "./pages/GerenciamentoIfood"
import { Index as HistoricoAlteracoes } from "./pages/HistoricoAlteracoes"
import { Index as ImpressoesDoDia } from "./pages/ImpressoesDoDia"
import { Index as HistoricoFechamentos } from "./pages/HistoricoFechamentos"
import { Index as HistoricoVersoes } from "./pages/HistoricoVersoes"
import { Index as ImportacaoClientesFornecedor } from "./pages/ImportacaoClientesFornecedor"
import { Index as IndicacoesAmigos } from "./pages/IndicacoesAmigos"
import { Index as IntegracaoDigiSac } from "./pages/IntegracaoDigiSac"
import { Index as IntegracaoFlux } from "./pages/IntegracaoFlux"
import { Index as IntegracaoPickngo } from "./pages/IntegracaoPickngo"
import { Index as IntegracaoFoodyDelivery } from "./pages/IntegracaoFoodyDelivery"
import { Index as IntegracaoOpenDelivery } from "./pages/IntegracaoOpenDelivery"
import { Index as IntegracaoPagSeguro } from "./pages/IntegracaoPagSeguro"
import { Index as IntegracaoRede } from "./pages/IntegracaoRede"
import { Index as IntegracaoRepediu } from "./pages/IntegracaoRepediu"
import { Index as IntegracaoWhatsapp } from "./pages/IntegracaoWhatsapp"
import { Index as ListarEntregadores } from "./pages/ListarEntregadores"
import { Index as ListarProdutos } from "./pages/ListarProdutos"
import { Index as Roteirizacao } from "./pages/Roteirizacao"
import { Index as MarketingAutomatico } from "./pages/MarketingAutomatico"
import { Index as ModeloIzzaGPT } from "./pages/ModeloIzzaGPT"
import { Index as ModulosFornecedor } from "./pages/ModulosFornecedor"
import { Index as AssinaturaEstabelecimento } from "./pages/AssinaturaEstabelecimento"
import { Index as NotificacaoPush } from "./pages/NotificacaoPush"
import { Index as OpenDeliveryIntegradores } from "./pages/OpenDeliveryIntegradores"
import { Index as OpenDeliverySimulador } from "./pages/OpenDeliverySimulador"
import { Index as ParametroIntegracaoUber } from "./pages/ParametroIntegracaoUber"
import { TelaParametros } from "./pages/Parametros"
import Robo from "./pages/Robo"
import PDVoz from "./pages/PDVoz"
import { Index as PerguntaPesquisaSatisfacao } from "./pages/PerguntaPesquisaSatisfacao"
import { Index as PeriodoEntregaFornecedor } from "./pages/PeriodoEntregaFornecedor"
import { Index as PesquisaSatisfacaoFornecedor } from "./pages/PesquisaSatisfacaoFornecedor"
import { Index as PosicaoClientes } from "./pages/PosicaoClientes"
import { Index as RespostasPersonalizadasIzza } from "./pages/RespostasPersonalizadasIzza"
import { Index } from "./pages/ResultadosFimDeAno"
import { Index as ResumoFornecedor } from "./pages/ResumoFornecedor"
import { Index as SeloPremiadoFornecedor } from "./pages/SeloPremiadoFornecedor"
import { Index as TelefoneBloqueados } from "./pages/TelefoneBloqueados"
import { Index as TextoImpressao } from "./pages/textoImpressao/Index"
import { Index as UsuariosPainel } from "./pages/UsuariosPainel"
import { Index as VerEnviosIzza } from "./pages/VerEnviosIzza"
import { Index as VerNotificacoesFornecedor } from "./pages/VerNotificacoesFornecedor"
import useAppStore from "./stores/AppStore"
import { CORES } from "./utils/coresPainel"
import { useSnackbar } from "./utils/notificacoes"

const switchLigadoVerde = {
    "&$checked": { color: "#4caf50" },
    "&$checked + $track": { backgroundColor: "#000", opacity: 0.5 },
}

// Tema ÚNICO do painel, fixo na paleta central (src/utils/coresPainel.ts). Não lê mais as
// cores do app do estabelecimento (aplicativoCF.corSitePrimaria/Secundaria): a barra
// superior e os botões ficam iguais para todos e não dependem do cache do aplicativo.
const criarTema = () => {
    return {
        palette: {
            primary: {
                light: CORES.marca,
                main: CORES.marca,
                contrastText: `#fff`,
            },
            secondary: {
                light: CORES.secundaria,
                main: CORES.secundaria,
                contrastText: `#fff`,
            },
            success: {
                main: CORES.sucesso,
                contrastText: `#fff`,
            },
            error: {
                main: CORES.erro,
                contrastText: `#fff`,
            },
            background: {
                default: CORES.fundo,
                paper: CORES.superficie,
            },
        },
        overrides: {
            // Padrão único dos switches do painel: ligado = bolinha verde e trilho cinza um tom
            // mais escuro que o desligado (preto 50%, contra os 38% padrão do MUI). Fica no tema
            // para não depender da cor primária/secundária do aplicativo.
            MuiSwitch: {
                colorPrimary: switchLigadoVerde,
                colorSecondary: switchLigadoVerde,
            },
        },
    }
}

const temaPainel = createTheme(criarTema())

const RouteDadosDeslogado = ({ component: Component, ...rest }) => {
    var aplicativoDados

    try {
        aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
        if (aplicativoDados.codErro > 0 || typeof aplicativoDados === "string") {
            localStorage.removeItem("aplicativoCF")
            return <Redirect to={"/" + rest.location.search} />
        }
    } catch (error) {
        localStorage.removeItem("aplicativoCF")
        return <Redirect to={"/" + rest.location.search} />
    }

    if (!aplicativoDados || aplicativoDados == null) {
        return <Redirect to={"/" + rest.location.search} />
    }
    headAdd(aplicativoDados)

    return (
        <ThemeProvider theme={temaPainel}>
            <Route
                {...rest}
                render={props =>
                    aplicativoDados &&
                    typeof aplicativoDados !== "string" /* && navigator.onLine */ ? (
                        <Component {...props} />
                    ) : (
                        <Redirect to="/" />
                    )
                }
            />
        </ThemeProvider>
    )
}

const headAdd = aplicativoDados => {
    const host = window.location.hostname || ""
    if (host.includes("localhost")) {
        document.title = "Local - Painel Cliente Fiel"
    } else if (host.includes("beta")) {
        document.title = "Beta - Cliente Fiel"
    } else {
        document.title = aplicativoDados.projectName
    }

    const shortCurt = document.createElement("link")
    shortCurt.setAttribute("rel", "shortcut icon")
    shortCurt.setAttribute("sizes", "192x192")
    shortCurt.setAttribute("href", aplicativoDados.urlLogo)
    document.head.insertAdjacentElement("beforeend", shortCurt)

    const shortCurt2 = document.createElement("link")
    shortCurt2.setAttribute("rel", "shortcut icon")
    shortCurt2.setAttribute("sizes", aplicativoDados.corSitePrimaria)
    shortCurt2.setAttribute("href", aplicativoDados.urlLogo)
    document.head.insertAdjacentElement("beforeend", shortCurt2)

    const themeLinkUrl = document.createElement("link")
    themeLinkUrl.setAttribute("rel", "icon")
    themeLinkUrl.setAttribute("href", aplicativoDados.urlLogo)
    document.head.insertAdjacentElement("beforeend", themeLinkUrl)
}

function removeNull(obj) {
    if (Array.isArray(obj)) return obj

    return Object.fromEntries(
        Object.entries(obj)
            .filter(([_, value]) => value != null)
            .map(([key, value]) => [key, value === Object(value) ? removeNull(value) : value])
    )
}

const RouteDadosLogado = ({ component: Component, ...rest }) => {
    var aplicativoDados
    var configs = useAppStore.getState().configuracoes
    var chaveSistema = localStorage.getItem("chaveSistema")

    try {
        aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))

        if (aplicativoDados.codErro > 0 || typeof aplicativoDados === "string") {
            localStorage.removeItem("aplicativoCF")
            return <Redirect to={"/" + rest.location.search} />
        }

        if (chaveSistema && !configs.user?.id) {
            return <Redirect to={"/?chave=" + chaveSistema} />
        }
    } catch (error) {
        localStorage.removeItem("aplicativoCF")
        return <Redirect to={"/" + rest.location.search} />
    }

    if (!chaveSistema || !aplicativoDados) {
        localStorage.removeItem("aplicativoCF")
        return <Redirect to={"/"} />
    } else if (rest.path !== "/" && rest.path !== "/login" && !chaveSistema) {
        // TODO IMPORTANTE:
        const configs = useAppStore.getState().configuracoes
        configs.user = {}
        localStorage.clear()
        localStorage.setItem("configs", JSON.stringify(removeNull(configs)))
        return <Redirect to={"/"} />
    }

    headAdd(aplicativoDados)

    return (
        <ThemeProvider theme={temaPainel}>
            <Route
                {...rest}
                render={props =>
                    aplicativoDados &&
                    typeof aplicativoDados !== "string" /* && navigator.onLine */ ? (
                        <Component {...props} />
                    ) : (
                        <Redirect to="/" />
                    )
                }
            />
        </ThemeProvider>
    )
}

// DELIVERY_BASICO / DELIVERY veem apenas o menu Pedidos, por isso ficam fora dos perfis completos
const PERFIS_COMPLETOS = ["ADMINISTRADOR", "CLIENTEFIEL"]
const PERFIS_ADMINISTRADORES = ["ADMINISTRADOR", "CLIENTEFIEL"]
const PERFIS_CLIENTEFIEL = ["CLIENTEFIEL"]
// Perfis que podem acessar o Cardápio: os completos + o perfil dedicado DELIVERY_CARDAPIO
const PERFIS_CARDAPIO = [...PERFIS_COMPLETOS, "DELIVERY_CARDAPIO"]
// Perfis que podem acessar o Caixa: os completos + os perfis de delivery
const PERFIS_CAIXA = [...PERFIS_COMPLETOS, "DELIVERY_BASICO", "DELIVERY", "DELIVERY_CARDAPIO"]
// Perfis que podem acessar a tela Pedidos do Dia: completos + todos os de delivery
const PERFIS_PEDIDOS_DIA = [...PERFIS_COMPLETOS, "DELIVERY", "DELIVERY_BASICO", "DELIVERY_CARDAPIO"]

const NaoAutorizado = () => {
    const history = useHistory()
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "80vh",
                gap: 16,
            }}
        >
            <Typography variant="h5">Acesso não autorizado</Typography>
            <Typography variant="body1" color="textSecondary">
                Seu perfil não tem permissão para acessar essa página.
            </Typography>
            <Button variant="contained" color="primary" onClick={() => history.push("/servicos")}>
                Voltar ao início
            </Button>
        </div>
    )
}

const RotaRestrita = ({ component: Component, perfisPermitidos, redirectTo, ...rest }) => {
    var aplicativoDados
    var configs = useAppStore.getState().configuracoes
    var chaveSistema = localStorage.getItem("chaveSistema")

    try {
        aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))

        if (aplicativoDados.codErro > 0 || typeof aplicativoDados === "string") {
            localStorage.removeItem("aplicativoCF")
            return <Redirect to={"/" + rest.location.search} />
        }

        if (chaveSistema && !configs.user?.id) {
            return <Redirect to={"/?chave=" + chaveSistema} />
        }
    } catch (error) {
        localStorage.removeItem("aplicativoCF")
        return <Redirect to={"/" + rest.location.search} />
    }

    if (!chaveSistema || !aplicativoDados) {
        localStorage.removeItem("aplicativoCF")
        return <Redirect to={"/"} />
    }

    headAdd(aplicativoDados)

    const perfilUsuario = configs?.user?.perfil
    const temPermissao = perfisPermitidos.includes(perfilUsuario)

    if (!temPermissao && redirectTo) {
        return <Redirect to={redirectTo} />
    }

    const ComponenteRenderizado = temPermissao ? Component : NaoAutorizado

    return (
        <ThemeProvider theme={temaPainel}>
            <Route
                {...rest}
                render={props =>
                    aplicativoDados && typeof aplicativoDados !== "string" ? (
                        <ComponenteRenderizado {...props} />
                    ) : (
                        <Redirect to="/" />
                    )
                }
            />
        </ThemeProvider>
    )
}

let enqueueSnackbarRef

export const alertStart = (msg, tipo) => {
    if (enqueueSnackbarRef) enqueueSnackbarRef(msg, { variant: tipo })
}

const Routes = () => {
    const { enqueueSnackbar } = useSnackbar()
    enqueueSnackbarRef = enqueueSnackbar
    const history = useHistory()
    const location = useLocation()

    useEffect(() => {
        const path = location.pathname || ""
        const noRecebedor =
            path.includes("recebedor-de-pedidos") || path.includes("aceitar-pedidos")
        if (noRecebedor) document.body.classList.add("recebedor-ativo")
        else document.body.classList.remove("recebedor-ativo")
    }, [location.pathname])

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))
    const versaoLancamento = "V" + Package.version
    localStorage.setItem("versao", `${versaoLancamento} | `)
    var aplicativoDados = {}
    try {
        aplicativoDados = JSON.parse(localStorage.getItem("aplicativoCF"))
        if (aplicativoDados.codErro > 0 || typeof aplicativoDados === "string") {
            localStorage.removeItem("aplicativoCF")
        }
    } catch (error) {
        localStorage.removeItem("aplicativoCF")
    }

    if (window.caches) {
        try {
            window.caches.keys().then(cacheNames => {
                cacheNames.forEach(cacheName => {
                    caches.delete(cacheName)
                })
            })
        } catch (error) {}
    }

    const configuracoes = useAppStore(state => state.configuracoes)
    const logado = !!configuracoes?.user?.id

    useEffect(() => {
        const app = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches

        if (!app) return
        if (!logado) return

        const jaRedirecionou = sessionStorage.getItem("direcionamentoInicial")
        if (jaRedirecionou) return

        if (location.pathname === "/servicos") {
            sessionStorage.setItem("direcionamentoInicial", "1")
            history.replace("/servicos/modulo/recebedor-de-pedidos")
        }
    }, [history, location.pathname, logado])

    return (
        <div className="global">
            <span
                id="versao-atual"
                style={{ cursor: "pointer", zIndex: "99999999", color: "white" }}
                onClick={() => {
                    window.location.href = window.location.href
                }}
            >
                {versaoLancamento}
            </span>
            <ThemeProvider theme={temaPainel}>
                <Switch>
                    <Route path="/" exact component={Filter} />
                    <Route path={"/teste"} exact component={Teste} />
                    <Route path={"/comece-agora"} exact component={OnboardingRestaurante} />
                    <Route path={"/login/loginUnificado"} component={Facebook} />
                    {/* Página pública de fatura (fatura.clientefiel.app). O link é enviado por
                        e-mail ao responsável e aberto pela faixa do painel, então não pode exigir
                        login — a RotaRestrita anterior redirecionava qualquer não-admin. Os dados
                        vêm de comum/fatura/{id}, que também é público. */}
                    <Route path={"/servicos/modulo/fatura/:idFatura"} component={Faturas} />
                    <Route path={"/retrospectiva"} component={Index} />

                    <RouteDadosDeslogado path={"/login"} component={Login} />

                    <RotaRestrita
                        path="/servicos"
                        exact
                        component={Servicos}
                        perfisPermitidos={PERFIS_COMPLETOS}
                        redirectTo="/servicos/modulo/recebedor-de-pedidos"
                    />

                    <RotaRestrita
                        path={"/servicos/ferramenta/edicao-cardapio/:tela"}
                        component={Cardapio}
                        perfisPermitidos={PERFIS_CARDAPIO}
                    />

                    <RouteDadosLogado path={"/servicos/ferramenta/galeria"} component={Galeria} />

                    <RouteDadosLogado path={"/qr-codes-mesas"} component={QRCodeMesa} />
                    <RouteDadosLogado
                        path={"/servicos/modulo/pedido-de-mesa"}
                        component={PedidoDeMesaQrCode}
                    />

                    <RouteDadosLogado path={"/aceitar-pedidos"} component={RecebedorDePedidos} />
                    <RouteDadosLogado
                        path={"/recebedor-de-pedidos"}
                        component={RecebedorDePedidos}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/recebedor-de-pedidos"}
                        component={RecebedorDePedidos}
                    />

                    <RouteDadosLogado
                        path={"/registrador-de-pedidos"}
                        component={RealizadorDePedidos}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/registrador-de-pedidos"}
                        component={RealizadorDePedidos}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/caixa"}
                        component={Caixa}
                        perfisPermitidos={PERFIS_CAIXA}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/historico-caixa"}
                        component={HistoricoCaixa}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/nota-fiscal"}
                        component={NotaFiscal}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/historico-pedidos"}
                        component={HistoricoPedidos}
                    />
                    <RotaRestrita
                        path={"/servicos/modulo/pedidos-do-dia"}
                        component={PedidosDoDia}
                        perfisPermitidos={PERFIS_PEDIDOS_DIA}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/dados-estabelecimento"}
                        component={CadastroEstabelecimento}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/gerenciador-de-mesas/:idMesa?"}
                        component={GerenciadorMesas}
                    />

                    <RotaRestrita
                        path={"/servicos/ferramenta/definir-area-de-entrega"}
                        component={AreaDeEntregas}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/historico-mesas"}
                        component={MesasFechadas}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/gerador-de-qrcode"}
                        component={GeradorDeQrCode}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/agendamento-configuracoes"}
                        component={ConfiguracoesAgendamento}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/agendamento-periodos"}
                        component={PeriodoAgendamento}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/pedidos-agendados"}
                        component={PedidosAgendados}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RouteDadosLogado path={"/servicos/modulo/pdvoz"} component={PDVoz} />

                    <RouteDadosLogado
                        path={"/servicos/modulo/conversas-whatsapp"}
                        component={ConversasWhatsapp}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/parametros-gerais"}
                        component={TelaParametros}
                        perfisPermitidos={PERFIS_CLIENTEFIEL}
                    />
                    <RotaRestrita
                        path={"/servicos/modulo/robo"}
                        component={Robo}
                        perfisPermitidos={PERFIS_CLIENTEFIEL}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/envio-template-whatsapp-grupo"}
                        component={EnvioTemplateWhatsappGrupo}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/criar-template-whatsapp"}
                        component={CriarTemplateWhatsapp}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-whatsapp"}
                        component={IntegracaoWhatsapp}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/texto-impressao"}
                        component={TextoImpressao}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/dados-fornecedor"}
                        component={DadosFornecedor}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-aplicativo"}
                        component={EditarAplicativo}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/criar-aplicativo"}
                        component={CriarAplicativo}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-layout/cores-aplicativo"}
                        component={CadastroAplicativoFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-layout/cadastro-aplicativo"}
                        component={CadastroAplicativoFornecedorCadastro}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-layout/parametros-aplicativo"}
                        component={CadastroAplicativoFornecedorParametros}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-layout/arquivos-aplicativo"}
                        component={CadastroAplicativoFornecedorArquivos}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-layout/contrato-aplicativo"}
                        component={CadastroAplicativoFornecedorContrato}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/editar-layout/estabelecimentos-aplicativo"}
                        component={CadastroAplicativoFornecedorEstabelecimentos}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/dados-bancarios"}
                        component={DadosBancariosSubconta}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/perguntas-pesquisa-satisfacao"}
                        component={PerguntaPesquisaSatisfacao}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/pesquisa-satisfacao-fornecedor"}
                        component={PesquisaSatisfacaoFornecedor}
                    />

                    <RouteDadosLogado path={"/historico-versoes"} component={HistoricoVersoes} />

                    <RouteDadosLogado
                        path={"/servicos/modulo/faixas-distancia"}
                        component={AtribuirFaixasDistancia}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/bairros"}
                        component={AtribuirRegiao}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/atribuir-bairros"}
                        component={AtribuirBairros}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/enderecos-bloqueados"}
                        component={EnderecosBloqueados}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/telefones-bloqueados"}
                        component={TelefoneBloqueados}
                    />
                    <RouteDadosLogado
                        path={"/servicos/modulo/horarios-delivery"}
                        component={PeriodoEntregaFornecedor}
                    />

                    <RouteDadosLogado
                        path={"/configuracao-formas-pagamento"}
                        component={ConfiguracaoFormasDePagamento}
                    />

                    <RotaRestrita
                        path={"/cartelas"}
                        component={CartelasFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RouteDadosLogado path={"/clientes/:idCliente"} component={EdicaoCliente} />

                    <RouteDadosLogado path={"/clientes"} component={ClientesFornecedor} />

                    <RotaRestrita
                        path={"/posicao-clientes"}
                        component={PosicaoClientes}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RouteDadosLogado
                        path={"/importacao-clientes"}
                        component={ImportacaoClientesFornecedor}
                    />

                    <RouteDadosLogado path={"/avaliacao-delivery"} component={AvaliacaoDelivery} />

                    <RotaRestrita
                        path={"/servicos/modulo/resumo"}
                        component={ResumoFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/modulos-contratados"}
                        component={ModulosFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/assinatura"}
                        component={AssinaturaEstabelecimento}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/estrategias"}
                        component={EstrategiasFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/promocao-fidelidade"}
                        component={CadastroPromocaoFidelidade}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/selos-premiados"}
                        component={SeloPremiadoFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/banners"}
                        component={CadastroBannerFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/respostas-personalizadas-izza"}
                        component={RespostasPersonalizadasIzza}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/modelo-izza-gpt"}
                        component={ModeloIzzaGPT}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/indicacoes-amigos"}
                        component={IndicacoesAmigos}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/clube-beneficios"}
                        component={ClubeBeneficios}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/envios-izza"}
                        component={VerEnviosIzza}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/listar-produtos"}
                        component={ListarProdutos}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/historico-caixa"}
                        component={HistoricoCaixa}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/historico-fechamentos"}
                        component={HistoricoFechamentos}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/historico-alteracoes"}
                        component={HistoricoAlteracoes}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    {/* Histórico de impressões enviadas para a loja no dia (conferência) */}
                    <RotaRestrita
                        path={"/servicos/modulo/impressoes-do-dia"}
                        component={ImpressoesDoDia}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    {/* Relatório de Pedidos desativado: unificado no Histórico de Pedidos. */}
                    <Redirect from={"/relatorio-pedidos"} to={"/servicos/modulo/historico-pedidos"} />

                    <RotaRestrita
                        path={"/brindes-resgatados"}
                        component={BrindesResgatadosFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/promocoes"}
                        component={BrindesFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/comparativo-unidades"}
                        component={ComparativoUnidades}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/notificacoes"}
                        component={VerNotificacoesFornecedor}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/notificacao-push"}
                        component={NotificacaoPush}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/marketing/marketing-automatico"}
                        component={MarketingAutomatico}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/entregadores"}
                        component={ListarEntregadores}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/roteirizacao"}
                        component={Roteirizacao}
                        perfisPermitidos={PERFIS_COMPLETOS}
                    />

                    <RotaRestrita
                        path={"/fiscal/emissoes-para-meu-cnpj"}
                        component={EmissoesParaMeuCNPJ}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/fiscal/importar-notas-compra"}
                        component={ImportarNotasCompra}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/fiscal/emissao-cupom-fiscal"}
                        component={EmissaoCupomFiscal}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/fiscal/configuracao-fiscal"}
                        component={ConfiguracaoFiscal}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/pix/extrato-detalhado"}
                        component={ExtratoPixFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/pix/extrato-pagarme"}
                        component={ExtratoPagarmeFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/cupons/desconto"}
                        component={CupomEstabelecimentoFornecedor}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/configuracao-delivery/parametros-delivery"}
                        component={ConfiguracaoDeliveryParametros}
                    />

                    <RouteDadosLogado
                        path={"/servicos/modulo/configuracao-delivery/parametros-avancados"}
                        component={ConfiguracaoDeliveryAvancados}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/configuracao-delivery/parametros-cliente-fiel"}
                        component={ConfiguracaoDeliveryClienteFiel}
                        perfisPermitidos={PERFIS_CLIENTEFIEL}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/configuracao-delivery/parametros-integracao"}
                        component={ConfiguracaoDeliveryIntegracao}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-foody-delivery"}
                        component={IntegracaoFoodyDelivery}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-opendelivery"}
                        component={IntegracaoOpenDelivery}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/testar-opendelivery"}
                        component={OpenDeliverySimulador}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    {/* Cadastro dos parceiros homologados: so a equipe Cliente Fiel */}
                    <RotaRestrita
                        path={"/servicos/modulo/opendelivery-integradores"}
                        component={OpenDeliveryIntegradores}
                        perfisPermitidos={PERFIS_CLIENTEFIEL}
                    />

                    {/* CRUD de usuarios do painel: so a equipe Cliente Fiel */}
                    <RotaRestrita
                        path={"/servicos/modulo/usuarios"}
                        component={UsuariosPainel}
                        perfisPermitidos={PERFIS_CLIENTEFIEL}
                    />

                    {/* Avisos do sino do painel (cache), equivalente ao CadastroAlertasPainel */}
                    <RotaRestrita
                        path={"/servicos/modulo/alertas-painel"}
                        component={AlertasPainel}
                        perfisPermitidos={PERFIS_CLIENTEFIEL}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-repediu"}
                        component={IntegracaoRepediu}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-digisac"}
                        component={IntegracaoDigiSac}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-pagseguro"}
                        component={IntegracaoPagSeguro}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-rede"}
                        component={IntegracaoRede}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-flux"}
                        component={IntegracaoFlux}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-pickngo"}
                        component={IntegracaoPickngo}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-uber"}
                        component={ParametroIntegracaoUber}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <RotaRestrita
                        path={"/servicos/modulo/integracao-ifood"}
                        component={GerenciamentoIfood}
                        perfisPermitidos={PERFIS_ADMINISTRADORES}
                    />

                    <Route component={Filter} />
                </Switch>
                <DivulgacoesPainel />
                <BannerQuitacao />
            </ThemeProvider>
        </div>
    )
}

export default Routes
